import React, { useEffect, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as contactUsSlice from "../../../../redux/slices/contactUsSlice";

const ContactUsDetailsPage = ({ selectedCart }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { cartDetails, contactUsDetails } = useSelector(
    (state) => state.contactUsSlice
  );

  useEffect(() => {
    if (!params.id) return;
    dispatch(contactUsSlice.getContactUsDetails(params.id));
  }, [params.id]);

  const handleUpdate = async (status) => {
    await dispatch(contactUsSlice.updateForm(params.id, { status }));
    dispatch(contactUsSlice.getContactUsDetails(params.id));
  };

  const handleSendEmail = () => {
    navigate("/email", {
      state: {
        recipientEmail: contactUsDetails?.email,
        recipientName: contactUsDetails?.first_name,
        subject: `Re: Contact Form Inquiry - ${contactUsDetails?.first_name}`,
        message: `Dear ${contactUsDetails?.first_name},\n\nThank you for contacting us regarding:\n\n"${contactUsDetails?.message}"\n\nWe appreciate you reaching out to us.\n\nBest regards,\nTemple Travel Team`
      }
    });
  };

  return (
    <div className="">
      <div className="text-left mt-4">
        <Button
          style={{ backgroundColor: "#e8783d", border: "none", marginRight: "10px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        {contactUsDetails?.email && (
          <Button
            style={{ backgroundColor: "#4CAF50", border: "none" }}
            onClick={handleSendEmail}
          >
            Reply via Email
          </Button>
        )}
      </div>
      <h1 className="text-center">Contact Us Details</h1>
      <Row className="g-3 mt-4">
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Name:</strong> {contactUsDetails?.first_name || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Email:</strong> {contactUsDetails?.email || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Mobile Number:</strong> {contactUsDetails?.mobile_no || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Message:</strong> {contactUsDetails?.message || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Status:</strong>
            {contactUsDetails?.status === 1 ? "Pending" : "Approved"}
          </p>
        </Col>

        {contactUsDetails?.status === 1 && (
          <Col xs={12} md={6} lg={4}>
            <p>
              <strong>Status:</strong>
              <Button
                style={{ marginLeft: "1vh" }}
                onClick={() => {
                  handleUpdate("2");
                }}
              >
                Approve
              </Button>
            </p>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ContactUsDetailsPage;
